import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { SubjectService } from 'src/app/providers/subject/subject.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-subject-modal',
  templateUrl: './subject-modal.component.html',
  styleUrls: ['./subject-modal.component.scss']
})
export class SubjectModalComponent implements OnInit {
  subjectForm: FormGroup;
  router: any;

  local_data: any;
  id: number;
  description: string;
  name: string;

  constructor(public fb: FormBuilder,
    public dialogRef: MatDialogRef<SubjectModalComponent>,
    private subjectService: SubjectService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.local_data = { ...data };
    this.id = this.local_data.id;

    if (!this.id) {
      this.createForm();
    } else {
      this.editForm();
    }
  }

  createForm() {
    this.subjectForm = new FormGroup({
      name: new FormControl(),
      description: new FormControl()

    });

    this.subjectForm = this.fb.group({
      name: ['', [Validators.required]],
      description: ['', [Validators.required]]

    })
  }

  editForm() {
    this.subjectForm = new FormGroup({
      name: new FormControl(),
      description: new FormControl()

    });

    this.subjectForm = this.fb.group({
      name: [this.data.name, [Validators.required]],
      description: [this.data.description, [Validators.required]]

    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  addSubject() {
    if (!this.id) {
      console.log(this.subjectForm.value);
      this.subjectService.addSubject(this.subjectForm.value)
        .pipe(map(
          data => { return data },
          err => { console.log(err); return err }
        ))
        .subscribe(
          data => {
            return data;
          },
          err => { alert("Invalid data"); console.log(err) }
        );
    } else {
      console.log(this.subjectForm.value);
      this.subjectService.editSubject(this.id, this.subjectForm.value)
        .pipe(map(
          data => { return data },
          err => { console.log(err); return err }
        ))
        .subscribe(
          data => {
            return data;
          },
          err => { alert("Invalid data"); console.log(err) }
        );
    }


  }

  ngOnInit(): void {
  }

}
